var React = require('react');

function PolarizationFilterInline (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"18.46 26.64 21.56 26.64 28.1 13.36 25.01 13.36 18.46 26.64","key":0}),React.createElement("polygon",{"points":"11.51 26.64 14.61 26.64 21.15 13.36 18.06 13.36 11.51 26.64","key":1}),React.createElement("path",{"d":"m20,4.73c-8.44,0-15.27,6.84-15.27,15.27s6.84,15.27,15.27,15.27,15.27-6.84,15.27-15.27-6.84-15.27-15.27-15.27Zm0,27.55c-6.77,0-12.27-5.51-12.27-12.27s5.51-12.27,12.27-12.27,12.27,5.51,12.27,12.27-5.51,12.27-12.27,12.27Z","key":2})]);
}

PolarizationFilterInline.defaultProps = {"width":"32","height":"32","id":"Warstwa_1","data-name":"Warstwa 1","viewBox":"0 0 40 40"};

module.exports = PolarizationFilterInline;

PolarizationFilterInline.default = PolarizationFilterInline;
